import { useRecoilValue } from 'recoil';
import dataManagementEntityAtom from 'ProjectManager/DataManagement/Common/recoil/dataManagementEntity/dataManagementEntityAtom';
import dataManagementEntities from 'ProjectManager/DataManagement/Common/constants/dataManagementEntities';
import useProjectGiveTextAnswerFunction from 'ProjectManager/DataManagement/Questionnaire/components/Question/Answers/hooks/giveTextAnswer/useProjectGiveTextAnswerFunction';
import useTemplateGiveTextAnswerFunction from 'ProjectManager/DataManagement/Questionnaire/components/Question/Answers/hooks/giveTextAnswer/useTemplateGiveTextAnswerFunction';

const useGiveTextAnswerFunction = (questionId, isCustomQuestion) => {
    const dataManagementEntity = useRecoilValue(dataManagementEntityAtom);

    const dataFromProject = useProjectGiveTextAnswerFunction(
        questionId,
        isCustomQuestion,
    );

    const dataFromTemplate = useTemplateGiveTextAnswerFunction(
        questionId,
        isCustomQuestion,
    );

    if (dataManagementEntity === dataManagementEntities.PROJECT) {
        return dataFromProject;
    }

    if (dataManagementEntity === dataManagementEntities.TEMPLATE) {
        return dataFromTemplate;
    }

    return {};
};

export default useGiveTextAnswerFunction;
